import React, { useMemo, useState } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { PERIOD } from '../constants';
import { ChartContext } from '../context';
import { getVisibleChartSources } from '../helpers';
import { useChartFormats } from '../hooks/useChartFormats';

const { Provider } = ChartContext;

const ChartProvider = ({ extend, children, intl: { formatMessage } }) => {
  const [chart, setChart] = useState(null);
  const [period, setPeriod] = useState(
    extend.isModal ? PERIOD.DAY : PERIOD.MONTH,
  );
  const [activeSource, setActiveSource] = useState(null);

  const formats = useChartFormats({ formatMessage });

  const sources = useMemo(() => getVisibleChartSources(chart), [chart]);

  return (
    <Provider
      value={{
        ...extend,
        chart,
        period,
        formats,
        sources,
        setChart,
        setPeriod,
        activeSource,
        setActiveSource,
      }}
    >
      {children}
    </Provider>
  );
};

ChartProvider.propTypes = {
  extend: PropTypes.object,
  children: PropTypes.node,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(ChartProvider);



// WEBPACK FOOTER //
// ./src/components/common/Charts/ChartProvider/index.jsx